<template>
  <div class="home">
    <div id="carousel" ref="carousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
      </div>
      <div class="carousel-inner">
          <div class="carousel-item active">
              <img class="d-block w-100" src="/images/slide1-20260621.jpg" alt="First slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide2-20260621.jpg" alt="Second slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide3-20260621.jpg" alt="Third slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide4-20260621.jpg" alt="Fourth slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide5-20260621.jpg" alt="Fifth slide">
          </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carousel" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
      </button>
    </div>

    <br />
    <div class="container">
      <div class="row justify-content-center align-items-center g-4 g-md-5">
          <div class="col-6 col-lg-3 text-center">
            <router-link to="/brands/the-coffee-club"><img src="/images/tcc.png" class="brand-icon" alt="The Coffee Club" /></router-link>
          </div>
          <div class="col-6 col-lg-3 text-center">
            <router-link to="/brands/coffee-hit"><img src="/images/CoffeeHit_Logo.png" class="brand-icon" alt="Coffee Hit" /></router-link>
          </div>
          <div class="col-6 col-lg-3 text-center">
            <router-link to="/brands/veneziano"><img src="/images/VCR_LOGO.png" class="brand-icon" alt="Veneziano" /></router-link>
          </div>
          <div class="col-6 col-lg-3 text-center">
            <router-link to="/brands/three-stories"><img src="/images/threestories.png" class="brand-icon" alt="Three Stories" /></router-link>
          </div>
      </div>

      <p class="tagline text-center">
        Minor DKL Food Group operates networks of stores across several iconic Australian brands, delivering delicious food, excellent coffee and outstanding service to our customers.
      </p>
    </div>
  </div>
</template>

<script>
import { Carousel } from 'bootstrap'

export default {
  name: 'home',
  mounted () {
    this.carousel = new Carousel(this.$refs.carousel, { ride: 'carousel' })
  },
  beforeUnmount () {
    if (this.carousel) {
      this.carousel.dispose()
    }
  }
}
</script>

<style scoped>
/* Brand icons below the hero: scale to fill their grid column.
   2 per row up through medium screens, 4 per row on large+ (set via
   the col-6 col-lg-3 grid classes in the template). */
.brand-icon {
  width: 100%;
  max-width: 220px;
  aspect-ratio: 1 / 1;
  object-fit: contain;
}

/* Tagline below the brand icons */
.tagline {
  font-family: 'Raleway', sans-serif;
  color: #5a5a5b;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  max-width: 850px;
  margin: 50px auto 10px;
  padding: 35px 45px;
  background-color: #f4f1ec;
  border-radius: 16px;
}

@media (max-width: 575.98px) {
  .tagline {
    font-size: 19px;
    padding: 28px 24px;
  }
}

/* Cap the hero carousel to the content width on large screens so it
   isn't oversized on x-large/xx-large displays */
@media (min-width: 1200px) {
  #carousel {
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (min-width: 1400px) {
  #carousel {
    max-width: 1320px;
  }
}
</style>
